import { lazy, Suspense, useMemo } from 'react';
import { HeroVideo } from '@/components/HeroVideo';
import { usePageMeta } from '@/hooks/usePageMeta';

// Lazy-load everything below the fold
const CatchphraseLazy = lazy(() =>
  import('@/components/Catchphrase').then((m) => ({ default: m.Catchphrase }))
);

const ServicesNavLazy = lazy(() =>
  import('@/components/ServicesNav').then((m) => ({ default: m.ServicesNav }))
);


const WallOfFriendsLazy = lazy(() =>
  import('@/components/WallOfFriends').then((m) => ({ default: m.WallOfFriends }))
);

const InstagramFeedLazy = lazy(() =>
  import('@/components/InstagramFeed').then((m) => ({ default: m.InstagramFeed }))
);

const HomeContactCTALazy = lazy(() =>
  import('@/components/HomeContactCTA').then((m) => ({ default: m.HomeContactCTA }))
);

const Index = () => {
  const breadcrumbLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://go4it.agency/" }
    ]
  }), []);

  usePageMeta({
    title: 'go4it.agency – Event Agentur Zürich | Brand Activation & Live Communication Schweiz',
    description: 'Professionelle Event Agentur in Zürich & Dietikon. Brand Activation, Promotion, Eventbau & Logistik in der Schweiz. Ihr Partner für unvergessliche Markenerlebnisse.',
    canonical: '/',
    jsonLd: breadcrumbLd,
  });

  return (
    <>
      <HeroVideo />
      <Suspense fallback={<div className="bg-background min-h-[40vh]" />}>
        <CatchphraseLazy />
      </Suspense>
      <Suspense fallback={<div className="bg-background min-h-[53vh]" />}>
        <ServicesNavLazy />
      </Suspense>
      <Suspense fallback={null}>
        <WallOfFriendsLazy />
      </Suspense>
      <Suspense fallback={null}>
        <InstagramFeedLazy />
      </Suspense>
      <Suspense fallback={null}>
        <HomeContactCTALazy />
      </Suspense>
    </>
  );
};

export default Index;
